const buildAnnotationsFromIds = (annotations, newIds) => {
  const currentIds = Object.keys(annotations);
  if (
    currentIds.length === newIds.length &&
    currentIds.every((id, index) => id === newIds[index])
  ) {
    return annotations;
  }

  return Object.fromEntries(newIds.map((key) => [key, annotations[key]]));
};

/** Front-most layer first (typical layers panel order). */
export const getLayerIdsForDisplay = (annotations) =>
  Object.keys(annotations).reverse();

/**
 * Reorder stack by moving one layer to a display-list index (0 = front).
 * @returns {Record<string, object>|null} new annotations map, or null if unchanged
 */
export const moveLayerInDisplayOrder = (annotations, layerId, toDisplayIndex) => {
  if (!annotations?.[layerId]) {
    return null;
  }

  const stackIds = Object.keys(annotations);
  const displayIds = getLayerIdsForDisplay(annotations);
  const fromDisplay = displayIds.indexOf(layerId);

  if (fromDisplay === -1) {
    return null;
  }

  const clampedTarget = Math.max(
    0,
    Math.min(toDisplayIndex, displayIds.length - 1),
  );

  if (fromDisplay === clampedTarget) {
    return null;
  }

  const nextDisplay = [...displayIds];
  const [item] = nextDisplay.splice(fromDisplay, 1);
  nextDisplay.splice(clampedTarget, 0, item);

  const newStackIds = [...nextDisplay].reverse();
  const next = buildAnnotationsFromIds(annotations, newStackIds);

  return next === annotations ? null : next;
};

export default moveLayerInDisplayOrder;
